import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
var StatusChipTemplate = function (_a) {
    var status = _a.status;
    var statusColors = {
        Published: 'success',
        Unpublished: 'warning'
    };
    return _jsx(Chip, { label: status, color: statusColors[status] || 'default', variant: 'filled' });
};
export default StatusChipTemplate;
